import React, { useContext } from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { components } from "react-select";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import Icon from "../../Icon/Icon";

const StyledGeoLocationButton = styled.div`
  min-width: 3rem;

  &:hover {
    cursor: pointer;
  }
`;

const StyledGeoLocationIndicator = styled.span`
  background-color: ${({ theme, $hasText }) =>
    $hasText ? theme.primaryColor : ""};
  color: ${({ theme }) => theme.negativeTextColor};
  font-weight: 700;
  font-size: 0.85rem;
`;

function LocationControl(controlProps) {
  const { selectProps, children } = controlProps;

  const { geoLocationIndicatorText } = useContext(ComponentContext);

  const tooltip = (props) => (
    <Tooltip id="location-tooltip" {...props}>
      Use your current location
    </Tooltip>
  );

  const elementClassName = classNames({
    "p-2 mx-2": !isEmpty(geoLocationIndicatorText),
  });

  return (
    <components.Control {...controlProps}>
      {children}
      <OverlayTrigger
        delay={{ hide: 400, show: 150 }}
        overlay={tooltip}
        placement="top"
      >
        <StyledGeoLocationButton
          className="d-flex justify-content-center align-items-center"
          onMouseDown={selectProps.onLocationClick}
          onTouchStart={selectProps.onLocationClick}
        >
          {selectProps.isGeolocationInProgress ? (
            <div
              className="spinner-border spinner-border-sm mx-2"
              role="status"
            />
          ) : (
            <StyledGeoLocationIndicator
              className={elementClassName}
              $hasText={!!geoLocationIndicatorText}
            >
              {!geoLocationIndicatorText && (
                <Icon
                  className="mx-2"
                  color={selectProps.locationButtonConfig.color}
                  data-bs-placement="top"
                  data-bs-toggle="tooltip"
                  icon="location"
                  size={24}
                />
              )}
              {geoLocationIndicatorText && geoLocationIndicatorText}
            </StyledGeoLocationIndicator>
          )}
        </StyledGeoLocationButton>
      </OverlayTrigger>
    </components.Control>
  );
}

export default LocationControl;
